// wordMiniGameJoker.js
var WordMiniGameJoker = pc.createScript('wordMiniGameJoker');

WordMiniGameJoker.attributes.add("cam", { type: "entity" });
WordMiniGameJoker.attributes.add("banner", { type: "entity" });
WordMiniGameJoker.attributes.add("coverPos1", { type: "entity" });
WordMiniGameJoker.attributes.add("coverPos2", { type: "entity" });
WordMiniGameJoker.attributes.add("shakeButton", { type: "entity" });

// initialize code called once per entity
WordMiniGameJoker.prototype.initialize = function () {

    WordMiniGameJoker.instance = this;

    if (PlayerManager.instance.userData.jokerTutorial == undefined || PlayerManager.instance.userData.jokerTutorial == "0" || PlayerManager.instance.userData.jokerTutorial == null) {
        this.entity.children[3].enabled = true;
        GameManager.instance.PauseGame();
    }
    else {
        this.entity.children[3].enabled = false;
    }

    this.entity.button.on('click', function (event) {

        this.jokerTutorialAnimation = false;

        this.buttonStatus = false;

        WordMiniGameJoker.instance.entity.button.active = false;
        WordMiniGameJoker.instance.shakeButton.button.active = false;

        if (PlayerManager.instance.userData.jokerTutorial == undefined || PlayerManager.instance.userData.jokerTutorial == false) {
            
            this.jokerTutorialAnimation = true;
            
            PlayerManager.instance.userData.jokerTutorial = true;
            PlayerManager.instance.SavePlayerData();

            this.entity.children[3].enabled = false;
            Timer.instance.ContinueTimer();
            TimeBar.instance.continueBar();
            Touch.instance.Continue();
        }

        if (playingMiniGameName == "Attention Game") {

            if (GameAnalyticsSdk.instance.gaStatus) {GameAnalytics("addDesignEvent", "JokerButtonMiniAttentionGame:Click", 1);}
            
            if (this.jokerTutorialAnimation == false) {
                
                rewardedType = adsType.JokerMiniAttentionGame;
                if (gdsdk !== 'undefined' && gdsdk.preloadAd !== 'undefined') {
                    gdsdk.showAd('rewarded')
                        .then(response => {
                        })
                        .catch(error => {
                            WordMiniGameJoker.instance.jokerAttentionGame();
                            console.log("Error Rewarded ADS");
                        });
                }

                //ADSManager.instance.OpenRewardVideo(adsEnum.JokerMiniAttentionGame);
            }
            else {
                this.jokerAttentionGame();
            }
        }
        else if (playingMiniGameName == "Word Game") {
            if (GameAnalyticsSdk.instance.gaStatus) {GameAnalytics("addDesignEvent", "JokerButtonMiniWordGame:Click", 1);}
            
            if (this.jokerTutorialAnimation == false) {
                
                rewardedType = adsType.JokerMiniWordGame;
                if (gdsdk !== 'undefined' && gdsdk.preloadAd !== 'undefined') {
                    gdsdk.showAd('rewarded')
                        .then(response => {
                        })
                        .catch(error => {
                            WordMiniGameJoker.instance.jokerAction();
                            console.log("Error Rewarded ADS");
                        });
                }

                //ADSManager.instance.OpenRewardVideo(adsEnum.JokerMiniWordGame);
            }
            else {
                this.jokerAction();
            }
        }
        else if (playingMiniGameName == "Link Game") {
            if (GameAnalyticsSdk.instance.gaStatus) {GameAnalytics("addDesignEvent", "JokerButtonMiniLinkGame:Click", 1);}
            
            if (this.jokerTutorialAnimation == false) {
                
                rewardedType = adsType.JokerMiniLinkGame;
                if (gdsdk !== 'undefined' && gdsdk.preloadAd !== 'undefined') {
                    gdsdk.showAd('rewarded')
                        .then(response => {
                        })
                        .catch(error => {
                            WordMiniGameJoker.instance.jokerLinkGame();
                            console.log("Error Rewarded ADS");
                        });
                }

                //ADSManager.instance.OpenRewardVideo(adsEnum.JokerMiniLinkGame);
            }
            else {
                this.jokerLinkGame();
            }
        }
        else if (playingMiniGameName == "Math Game") {
            if (GameAnalyticsSdk.instance.gaStatus) {GameAnalytics("addDesignEvent", "JokerButtonMiniMathGame:Click", 1);}

            if (this.jokerTutorialAnimation == false) {
                
                rewardedType = adsType.JokerMiniMathGame;
                if (gdsdk !== 'undefined' && gdsdk.preloadAd !== 'undefined') {
                    gdsdk.showAd('rewarded')
                        .then(response => {
                        })
                        .catch(error => {
                            WordMiniGameJoker.instance.jokerMathGame();
                            console.log("Error Rewarded ADS");
                        });
                }

                //ADSManager.instance.OpenRewardVideo(adsEnum.JokerMiniMathGame);
            }
            else {
                this.jokerMathGame();
            }
        }
    }, this);
};

// WordMiniGameJoker.prototype.update = function (dt) {

//     if (gdsdk !== 'undefined' && gdsdk.preloadAd !== 'undefined') {
//         gdsdk
//             .preloadAd('rewarded')
//             .then(response => {
//                 this.entity.button.active = true;
//                 this.entity.element.opacity = 1;
//                 this.entity.children[0].element.opacity = 1;
//                 this.entity.children[1].element.opacity = 1;
//                 this.entity.children[2].element.opacity = 1;
//             })
//             .catch(error => {
//                 this.entity.button.active = true;
//                 this.entity.element.opacity = 1;
//                 this.entity.children[0].element.opacity = 1;
//                 this.entity.children[1].element.opacity = 1;
//                 this.entity.children[2].element.opacity = 1;
//             });
//     }
//     else {
//         this.entity.button.active = false;
//         this.entity.element.opacity = 0.3;
//         this.entity.children[0].element.opacity = 0.3;
//         this.entity.children[1].element.opacity = 0.3;
//         this.entity.children[2].element.opacity = 0.3;
//     }
// };
WordMiniGameJoker.prototype.jokerMathGame = function () {

    let jokerObject1 = null;
    let jokerObject2 = null;

    if (spawnPositions[0].findByTag("dropped").length >= 1) {

        CoverManager.instance.eventNum1.element.text = "_";
        CoverManager.instance.eventNum2.element.text = "_";
        let objectOnTheCover = spawnPositions[0].findByTag("dropped")[0];
        objectOnTheCover.tags.remove('dropped');
        objectOnTheCover.rigidbody.teleport(objectOnTheCover.parent.getPosition().x, objectOnTheCover.parent.getPosition().y, objectOnTheCover.parent.getPosition().z);
        objectOnTheCover.rigidbody.enabled = true;

    }

    if (GameManager.instance.eventData.mathChallengeOperationKey == "addition") {
        for (i = 0; i < SpawnManager.instance.SpawnPosition.children.length; i++) {

            let num1 = parseInt(SpawnManager.instance.SpawnPosition.children[i].tags.list()[1]);

            for (j = 0; j < SpawnManager.instance.SpawnPosition.children.length; j++) {

                let num2 = parseInt(SpawnManager.instance.SpawnPosition.children[j].tags.list()[1]);

                let result = num1 + num2;

                if (result == parseInt(GameManager.instance.eventData.matchKey)) {

                    jokerObject1 = SpawnManager.instance.SpawnPosition.children[i];
                    jokerObject2 = SpawnManager.instance.SpawnPosition.children[j];

                    CoverManager.instance.eventNum1.element.text = num1;
                    CoverManager.instance.eventNum2.element.text = num2;
                    setTimeout(() => {
                        CoverManager.instance.mathStatusIndicator.tween(CoverManager.instance.mathStatusIndicator.getLocalScale()).to(new pc.Vec3(1.5, 1.5, 1.5), 0.5, pc.SineOut).yoyo(true).repeat(2).on('complete', function () { CoverManager.instance.eventNum1.element.text = "_"; CoverManager.instance.eventNum2.element.text = "_"; }).start();
                    }, 700, this);

                    jokerObject1.rigidbody.enabled = false;
                    jokerObject1.tween(jokerObject1.getLocalEulerAngles()).rotate(CoverManager.instance.GetRotate(jokerObject1), 0.3, pc.Linear).start();
                    jokerObject1.tween(jokerObject1.getLocalPosition()).to(WordMiniGameJoker.instance.coverPos2.getLocalPosition(), 0.8, pc.Linear).start();


                    jokerObject2.rigidbody.enabled = false;
                    jokerObject2.tween(jokerObject2.getLocalEulerAngles()).rotate(CoverManager.instance.GetRotate(jokerObject2), 0.3, pc.Linear).start();
                    jokerObject2.tween(jokerObject2.getLocalPosition()).to(WordMiniGameJoker.instance.coverPos1.getLocalPosition(), 0.8, pc.Linear).on("complete", function () {
                        setTimeout(() => {
                            CoverManager.instance.ObjectStageTwo(jokerObject1, jokerObject2);
                            Timer.instance.ContinueTimer();
                            TimeBar.instance.continueBar();
                            Touch.instance.Continue();
                        }, 300, this);
                        setTimeout(() => {
                            WordMiniGameJoker.instance.entity.button.active = true;
                            WordMiniGameJoker.instance.shakeButton.button.active = true;
                        }, 1300, this);
                    }).start();
                    return;
                }
            }
        }
    }
    else if (GameManager.instance.eventData.mathChallengeOperationKey == "subtraction") {

        for (i = SpawnManager.instance.SpawnPosition.children.length - 1; i >= 0; i--) {

            let num1 = parseInt(SpawnManager.instance.SpawnPosition.children[i].tags.list()[1]);

            for (j = 0; j < SpawnManager.instance.SpawnPosition.children.length; j++) {

                let num2 = parseInt(SpawnManager.instance.SpawnPosition.children[j].tags.list()[1]);
                let result = num1 - num2;

                if (result == parseInt(GameManager.instance.eventData.matchKey)) {

                    jokerObject1 = SpawnManager.instance.SpawnPosition.children[i];
                    jokerObject2 = SpawnManager.instance.SpawnPosition.children[j];

                    CoverManager.instance.eventNum1.element.text = num1;
                    CoverManager.instance.eventNum2.element.text = num2;

                    setTimeout(() => {
                        CoverManager.instance.mathStatusIndicator.tween(CoverManager.instance.mathStatusIndicator.getLocalScale()).to(new pc.Vec3(1.5, 1.5, 1.5), 0.5, pc.SineOut).yoyo(true).repeat(2).on('complete', function () { CoverManager.instance.eventNum1.element.text = "_"; CoverManager.instance.eventNum2.element.text = "_"; }).start();
                    }, 700, this);


                    jokerObject1.rigidbody.enabled = false;
                    jokerObject1.tween(jokerObject1.getLocalEulerAngles()).rotate(CoverManager.instance.GetRotate(jokerObject1), 0.3, pc.Linear).start();
                    jokerObject1.tween(jokerObject1.getLocalPosition()).to(WordMiniGameJoker.instance.coverPos2.getLocalPosition(), 0.8, pc.Linear).start();


                    jokerObject2.rigidbody.enabled = false;
                    jokerObject2.tween(jokerObject2.getLocalEulerAngles()).rotate(CoverManager.instance.GetRotate(jokerObject2), 0.3, pc.Linear).start();
                    jokerObject2.tween(jokerObject2.getLocalPosition()).to(WordMiniGameJoker.instance.coverPos1.getLocalPosition(), 0.8, pc.Linear).on("complete", function () {
                        setTimeout(() => {
                            CoverManager.instance.ObjectStageTwo(jokerObject1, jokerObject2);
                            Timer.instance.ContinueTimer();
                            TimeBar.instance.continueBar();
                            Touch.instance.Continue();
                        }, 300, this);
                        setTimeout(() => {
                            WordMiniGameJoker.instance.entity.button.active = true;
                            WordMiniGameJoker.instance.shakeButton.button.active = true;
                        }, 1300, this);
                    }).start();
                    return;
                }
            }
        }
    }
    else if (GameManager.instance.eventData.mathChallengeOperationKey == "multiplication") {

        for (i = 0; i < SpawnManager.instance.SpawnPosition.children.length; i++) {

            let num1 = parseInt(SpawnManager.instance.SpawnPosition.children[i].tags.list()[1]);

            for (j = 0; j < SpawnManager.instance.SpawnPosition.children.length; j++) {

                let num2 = parseInt(SpawnManager.instance.SpawnPosition.children[j].tags.list()[1]);

                let result = num1 * num2;

                if (result == parseInt(GameManager.instance.eventData.matchKey)) {

                    jokerObject1 = SpawnManager.instance.SpawnPosition.children[i];
                    jokerObject2 = SpawnManager.instance.SpawnPosition.children[j];

                    CoverManager.instance.eventNum1.element.text = num1;
                    CoverManager.instance.eventNum2.element.text = num2;

                    setTimeout(() => {
                        CoverManager.instance.mathStatusIndicator.tween(CoverManager.instance.mathStatusIndicator.getLocalScale()).to(new pc.Vec3(1.5, 1.5, 1.5), 0.5, pc.SineOut).yoyo(true).repeat(2).on('complete', function () { CoverManager.instance.eventNum1.element.text = "_"; CoverManager.instance.eventNum2.element.text = "_"; }).start();
                    }, 700, this);

                    jokerObject1.rigidbody.enabled = false;
                    jokerObject1.tween(jokerObject1.getLocalEulerAngles()).rotate(CoverManager.instance.GetRotate(jokerObject1), 0.3, pc.Linear).start();
                    jokerObject1.tween(jokerObject1.getLocalPosition()).to(WordMiniGameJoker.instance.coverPos2.getLocalPosition(), 0.8, pc.Linear).start();


                    jokerObject2.rigidbody.enabled = false;
                    jokerObject2.tween(jokerObject2.getLocalEulerAngles()).rotate(CoverManager.instance.GetRotate(jokerObject2), 0.3, pc.Linear).start();
                    jokerObject2.tween(jokerObject2.getLocalPosition()).to(WordMiniGameJoker.instance.coverPos1.getLocalPosition(), 0.8, pc.Linear).on("complete", function () {
                        setTimeout(() => {
                            CoverManager.instance.ObjectStageTwo(jokerObject1, jokerObject2);
                            Timer.instance.ContinueTimer();
                            TimeBar.instance.continueBar();
                            Touch.instance.Continue();
                        }, 300, this);
                        setTimeout(() => {
                            WordMiniGameJoker.instance.entity.button.active = true;
                            WordMiniGameJoker.instance.shakeButton.button.active = true;
                        }, 1300, this);
                    }).start();
                    return;
                }
            }
        }
    }
    else if (GameManager.instance.eventData.mathChallengeOperationKey == "division") {

        for (i = SpawnManager.instance.SpawnPosition.children.length - 1; i >= 0; i--) {

            let num1 = parseInt(SpawnManager.instance.SpawnPosition.children[i].tags.list()[1]);

            for (j = 0; j < SpawnManager.instance.SpawnPosition.children.length; j++) {

                let num2 = parseInt(SpawnManager.instance.SpawnPosition.children[j].tags.list()[1]);

                if ((num1 % num2) == 0) {

                    let result = num1 / num2;

                    if (result == parseInt(GameManager.instance.eventData.matchKey)) {
                        jokerObject1 = SpawnManager.instance.SpawnPosition.children[i];
                        jokerObject2 = SpawnManager.instance.SpawnPosition.children[j];

                        CoverManager.instance.eventNum1.element.text = num1;
                        CoverManager.instance.eventNum2.element.text = num2;
                        setTimeout(() => {
                            CoverManager.instance.mathStatusIndicator.tween(CoverManager.instance.mathStatusIndicator.getLocalScale()).to(new pc.Vec3(1.5, 1.5, 1.5), 0.5, pc.SineOut).yoyo(true).repeat(2).on('complete', function () { CoverManager.instance.eventNum1.element.text = "_"; CoverManager.instance.eventNum2.element.text = "_"; }).start();
                        }, 700, this);

                        jokerObject1.rigidbody.enabled = false;
                        jokerObject1.tween(jokerObject1.getLocalEulerAngles()).rotate(CoverManager.instance.GetRotate(jokerObject1), 0.3, pc.Linear).start();
                        jokerObject1.tween(jokerObject1.getLocalPosition()).to(WordMiniGameJoker.instance.coverPos2.getLocalPosition(), 0.8, pc.Linear).start();


                        jokerObject2.rigidbody.enabled = false;
                        jokerObject2.tween(jokerObject2.getLocalEulerAngles()).rotate(CoverManager.instance.GetRotate(jokerObject2), 0.3, pc.Linear).start();
                        jokerObject2.tween(jokerObject2.getLocalPosition()).to(WordMiniGameJoker.instance.coverPos1.getLocalPosition(), 0.8, pc.Linear).on("complete", function () {
                            setTimeout(() => {
                                CoverManager.instance.ObjectStageTwo(jokerObject1, jokerObject2); Timer.instance.ContinueTimer();
                                TimeBar.instance.continueBar();
                                Touch.instance.Continue();
                            }, 300, this);
                            setTimeout(() => {
                                WordMiniGameJoker.instance.entity.button.active = true;
                                WordMiniGameJoker.instance.shakeButton.button.active = true;
                            }, 1300, this);
                        }).start();
                        return;
                    }
                }
            }
        }
    }
};
WordMiniGameJoker.prototype.jokerLinkGame = function () {

    let randomNumber = Math.floor(Math.random() * matchThemeAssetList.length);

    let obj1;
    let obj2;

    if (spawnPositions[0].findByTag("dropped").length >= 1) {

        let objectOnTheCover = spawnPositions[0].findByTag("dropped")[0];
        objectOnTheCover.tags.remove('dropped');
        objectOnTheCover.rigidbody.teleport(objectOnTheCover.parent.getPosition().x, objectOnTheCover.parent.getPosition().y, objectOnTheCover.parent.getPosition().z);
        objectOnTheCover.rigidbody.enabled = true;
    }

    for (i = 0; i < SpawnManager.instance.SpawnPosition.children.length; i++) {

        if (SpawnManager.instance.SpawnPosition.children[i].name == matchThemeAssetList[randomNumber].id) {

            if (obj1 == undefined) {

                obj1 = SpawnManager.instance.SpawnPosition.children[i];

                obj1.tween(obj1.getLocalEulerAngles()).rotate(CoverManager.instance.GetRotate(obj1), 0.3, pc.Linear).start();
                obj1.tween(obj1.getLocalPosition()).to(WordMiniGameJoker.instance.coverPos1.getLocalPosition(), 0.8, pc.Linear).start();
                obj1.rigidbody.enabled = false;
            }
            else if (obj1 != undefined) {
                obj2 = SpawnManager.instance.SpawnPosition.children[i];

                obj2.tween(obj2.getLocalEulerAngles()).rotate(CoverManager.instance.GetRotate(obj2), 0.3, pc.Linear).start();
                obj2.tween(obj2.getLocalPosition()).to(WordMiniGameJoker.instance.coverPos2.getLocalPosition(), 0.8, pc.Linear).on("complete", function () {
                    
                    setTimeout(() => {
                        CoverManager.instance.ObjectStageTwo(obj1, obj2);
                        Timer.instance.ContinueTimer();
                        TimeBar.instance.continueBar();
                        Touch.instance.Continue();
                    }, 300, this);

                    matchThemeAssetList.splice(randomNumber, 1);

                    setTimeout(() => {
                        WordMiniGameJoker.instance.entity.button.active = true;
                        WordMiniGameJoker.instance.shakeButton.button.active = true;
                    }, 1300, this);

                }).start();

                obj2.rigidbody.enabled = false;
            }
        }
    }
};

WordMiniGameJoker.prototype.jokerAttentionGame = function () {

    let selectedAttentionIcon = this.app.assets.findByTag(findByAttentionObjects[0]);

    let obj1;
    let obj2;

    if (spawnPositions[0].findByTag("dropped").length >= 1) {

        let objectOnTheCover = spawnPositions[0].findByTag("dropped")[0];
        objectOnTheCover.tags.remove('dropped');
        objectOnTheCover.rigidbody.teleport(objectOnTheCover.parent.getPosition().x, objectOnTheCover.parent.getPosition().y, objectOnTheCover.parent.getPosition().z);
        objectOnTheCover.rigidbody.enabled = true;
    }

    for (i = 0; i < SpawnManager.instance.SpawnPosition.children.length; i++) {

        if (SpawnManager.instance.SpawnPosition.children[i].name == selectedAttentionIcon[0].id) {

            if (obj1 == undefined) {

                obj1 = SpawnManager.instance.SpawnPosition.children[i];

                obj1.tween(obj1.getLocalEulerAngles()).rotate(CoverManager.instance.GetRotate(obj1), 0.3, pc.Linear).start();
                obj1.tween(obj1.getLocalPosition()).to(WordMiniGameJoker.instance.coverPos1.getLocalPosition(), 0.8, pc.Linear).start();
                obj1.rigidbody.enabled = false;
            }
            else if (obj1 != undefined) {
                obj2 = SpawnManager.instance.SpawnPosition.children[i];

                obj2.tween(obj2.getLocalEulerAngles()).rotate(CoverManager.instance.GetRotate(obj2), 0.3, pc.Linear).start();
                obj2.tween(obj2.getLocalPosition()).to(WordMiniGameJoker.instance.coverPos2.getLocalPosition(), 0.8, pc.Linear).on("complete", function () {

                    setTimeout(() => {
                        CoverManager.instance.ObjectStageTwo(obj1, obj2);
                        Timer.instance.ContinueTimer();
                        TimeBar.instance.continueBar();
                        Touch.instance.Continue();
                    }, 300, this);

                    findByAttentionObjects.shift();

                    if (findByAttentionObjects.length > 0) {
                        EventsManager.instance.attentionObjectUpdateStatus();
                    }

                    setTimeout(() => {
                        WordMiniGameJoker.instance.entity.button.active = true;
                        WordMiniGameJoker.instance.shakeButton.button.active = true;
                    }, 1300, this);

                }).start();

                obj2.rigidbody.enabled = false;
            }
        }
    }
};

WordMiniGameJoker.prototype.jokerAction = function () {

    var bannerPos = this.cam.camera.screenToWorld(this.banner.getLocalPosition().x, this.banner.getLocalPosition().y, this.cam.camera.nearClip);
    var screenUpY = window.innerHeight - this.banner.getLocalPosition().y;
    var screenUpX = this.banner.getLocalPosition().x;
    var posz = this.cam.camera.screenToWorld(screenUpX, screenUpY, this.cam.camera.nearClip);

    let randomNumber = Math.floor(Math.random() * cloneSelectedWordKeys.length);
    let selectedCharacter = cloneSelectedWordKeys[randomNumber];

    let obj1;
    let obj2;


    for (i = 0; i < SpawnManager.instance.SpawnPosition.children.length; i++) {

        let obj = SpawnManager.instance.SpawnPosition.children[i].tags.list()[1];

        if (obj === selectedCharacter) {
            if (obj1 == undefined) {
                obj1 = SpawnManager.instance.SpawnPosition.children[i];
                obj1
                    .tween(obj1.getLocalEulerAngles())
                    .rotate(new pc.Vec3(0, 0, 0), 0.3, pc.Linear)
                    .yoyo(true).on('complete', function () {
                        obj1
                            .tween(obj1.getLocalPosition())
                            .to(new pc.Vec3(0, 5, 0), 1, pc.Linear)
                            .yoyo(true)
                            .start();
                    })
                    .start();
            }
            else if (obj1 != undefined) {
                obj2 = SpawnManager.instance.SpawnPosition.children[i];
                obj2.tween(obj2.getLocalEulerAngles()).rotate(new pc.Vec3(0, 0, 0), 0.3, pc.Linear).yoyo(true).on('complete', function () {
                    obj2
                        .tween(obj2.getLocalPosition())
                        .to(new pc.Vec3(0, 5, 0), 1.0, pc.SineOut)
                        .yoyo(true)
                        .on('complete', function () {
                            obj1.destroy();
                            obj2
                                .tween(obj2.getLocalPosition())
                                .to(new pc.Vec3(1, 0, -3.5), 0.5, pc.SineOut)
                                //.to(new pc.Vec3(posz.x,posz.z,-posz.y /2), 0.5, pc.SineOut)
                                .yoyo(true)
                                .on('complete', function () {
                                    EventsManager.instance.wordChallengeShowMatchLetters(selectedCharacter);
                                    CoverManager.instance.ObjectCounter();
                                    Timer.instance.ContinueTimer();
                                    TimeBar.instance.continueBar();
                                    Touch.instance.Continue();
                                })
                                .start();

                            obj2
                                .tween(obj2.getLocalScale())
                                .to(new pc.Vec3(0.2, 0.2, 0.2), 0.5, pc.SineOut)
                                .yoyo(true)
                                .on('complete', function () {
                                    obj2.destroy();
                                    setTimeout(() => {
                                        WordMiniGameJoker.instance.entity.button.active = true;
                                        WordMiniGameJoker.instance.shakeButton.button.active = true;
                                    }, 500, this);

                                })
                                .start();
                        })
                        .start();
                })
                    .start();
            }
        }
    }
};


